import { css } from '@emotion/css'

export const container = css`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  box-sizing: border-box;
  @media (max-width: 767px) {
    padding: 2em 0
  }

`

export const childContainer = css`
  background: transparent;
  width: 540px;
  right: 15%;
  max-width: 100%;
  padding: 0;
  position: absolute;
  z-index: 2;
  @media (max-width: 767px) {
    right: initial;
  }
`

export const bg = css`
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  width: 71%;
`
